
export default function Footer() {
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">会社概要</h3>
            <div className="space-y-2 text-gray-300">
              <p>PMモータース</p>
              <p>〒123-4567</p>
              <p>東京都〇〇区〇〇町1-2-3</p>
              <p>TEL: 0120-000-000</p>
              <p>認証工場番号: 第〇〇号</p>
            </div>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">営業時間</h3>
            <div className="space-y-2 text-gray-300">
              <p>平日: 9:00 - 18:00</p>
              <p>土曜: 9:00 - 17:00</p>
              <p>日曜・祝日: 定休日</p>
              <p className="text-orange-400 font-medium">緊急時は24時間対応</p>
            </div>
          </div>

          {/* Social Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">SNS・お問い合わせ</h3>
            <div className="flex space-x-4 mb-4">
              <a href="#" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a href="#" className="text-gray-300 hover:text-orange-400 transition-colors cursor-pointer">
                <i className="ri-line-fill text-2xl"></i>
              </a>
            </div>
            <div className="text-gray-300">
              <p className="mb-2">📞 0120-000-000</p>
              <p>受付時間: 9:00〜18:00</p>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-8 pt-8 border-t border-gray-700">
          <h3 className="text-lg font-semibold mb-4">アクセス</h3>
          <div className="bg-gray-200 rounded-lg overflow-hidden" style={{ height: '300px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.8280649159!2d139.69170731525394!3d35.68948998019441!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188b563b00109f%3A0x337328def1e2ab26!2z5p2x5Lqs6aeF!5e0!3m2!1sja!2sjp!4v1635000000000!5m2!1sja!2sjp"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-8 pt-8 border-t border-gray-700 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 PMモータース. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer mt-2 sm:mt-0"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
